import React from 'react';
import PropTypes from 'prop-types';

const LoadMoreButton = ({ onLoadMore, isLoading, disabled = false, 'data-testid': dataTestId }) => {
  const handleClick = () => {
    if (!isLoading && !disabled && onLoadMore) {
      onLoadMore();
    }
  };

  return (
      <button
          type="button"
          className="btn btn-default btn-lg text-uppercase mt16 mb16"
          onClick={handleClick}
          disabled={isLoading || disabled}
          data-testid={dataTestId}
      >
          {isLoading ? (
              <span data-testid={dataTestId && `${dataTestId}.loading`}>
                  <i className="fas fa-circle-notch fa-spin" /> Loading...
              </span>
      ) : (
          <span data-testid={dataTestId && `${dataTestId}.label`}>Load More</span>
      )}
      </button>
  );
};

LoadMoreButton.propTypes = {
  onLoadMore: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  'data-testid': PropTypes.string,
};

LoadMoreButton.defaultProps = {
  isLoading: false,
  disabled: false,
  'data-testid': null,
};

export default LoadMoreButton;
